// A6.13 — Mening navbatim adapter. Module-local. Pull-based ish taqsimoti:
// moderator "keyingi"ni oladi (claim), o'z navbatini ko'radi, kerak bo'lsa
// bo'shatadi. Backend claim-ni atomik (SKIP LOCKED) bajaradi.
import { api } from '@/lib/api'

export interface MyReport {
  id: number
  reporter_id?: number | null
  reporter_username?: string | null
  target_type: string
  target_id: number
  category: string
  reason?: string | null
  status: string
  created_at: number
  assigned_at?: number
}

export async function fetchMyQueue(limit = 100): Promise<MyReport[]> {
  const r = await api.get<{ items?: MyReport[] }>('/admin/moderation/mine', { query: { limit } })
  return r.items ?? []
}

// Keyingi eng-xavfli bo'sh shikoyatni menga biriktiradi. Bo'sh bo'lsa report=null.
export async function claimNextReport(): Promise<MyReport | null> {
  const r = await api.post<{ report: MyReport | null }>('/admin/moderation/claim-next', {})
  return r.report ?? null
}

export async function releaseReport(id: number): Promise<void> {
  await api.post(`/admin/reports/${id}/release`, {})
}
